import { trackPromise } from "react-promise-tracker";
import CommonUtil from "utils/CommonUtil";

/**
 * 메인 RestRepository
 */
const mainRestRepository = new (class MainRestRepository {
  private readonly path = "/";

  /**
   * 최근 목록 조회
   *
   * @param recordCount
   */
  public async getBanList(): Promise<any> {
    return await trackPromise(
      CommonUtil.axios()
        .get(this.path + "bannerList")
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          CommonUtil.showAxiosError(error);
        })
    );
  }
  /**
   * 최근 목록 조회
   *
   */
  public async getPopupList(): Promise<any> {
    return await trackPromise(
      CommonUtil.axios()
        .get(this.path + "popupList")
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          CommonUtil.showAxiosError(error);
        })
    );
  }
  /**
   * 배너 클릭 수 업데이트
   *
   * @param banNo
   */
  public async putBanClkCnt(banNo: string): Promise<any> {
    return await trackPromise(
      CommonUtil.axios()
        .post(this.path + "updateBanClkCnt", banNo)
        .then((response) => {
          return true;
        })
        .catch((error) => {
          CommonUtil.showAxiosError(error);
          return false;
        })
    );
  }
})();

export default mainRestRepository;
